import { ReactNode, useMemo } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { styles } from "./styles";

interface Props {
  id?: string;
  openInNewTab?: boolean;
  href?: string;
  disabled?: boolean;
  children: ReactNode;
  onClick?: () => void;
  isFilled?: boolean;
}

const ProfileCardIcon = ({
  children,
  href = undefined,
  id,
  isFilled = true,
  ...rest
}: Props): JSX.Element => {
  const link = useMemo(() => {
    if (!href) return "";
    return href.startsWith("http") ? href : `https://${href}`;
  }, [href]);

  return (
    <Button<"a">
      sx={styles.root}
      color="dark"
      disabled={!href}
      href={link}
      id={id}
      isExternal
      isIconButton
      target="_blank"
      rel="noopener noreferrer"
      size="xs"
      variant={isFilled ? "primary" : "ghost"}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ProfileCardIcon;
